module.exports = __webpack_public_path__ + "img/7.8e42522a.jpg";